
(function ( $ ) {
    "use strict";

    $.fn.uiSearchableList = function( options ) {

        let config	= {
            isInitializedClassName: 'ui-searchable-list-initialized'
        };

        // have default options.
        let settings = $.extend({
            itemSelector:	".ui-searchable-list-item",
            onEvents:	'input blur',
            dataTargetAttr : 'data-ui-searchable-target',
            sortSeparator: ':'
        }, options );

        let uiFilterSearchMatches = function(selector, searchValue) {

            if (typeof searchValue == 'undefined' || !searchValue) {
                $(selector).children(settings.itemSelector).show();
                return;
            }

            // we filter case-insensitive
            searchValue = searchValue.toLowerCase();
            let searchableItems = $(selector).children(settings.itemSelector);

            // search
            searchableItems.hide();
            searchableItems.each(function(){
                if($(this).text().toLowerCase().indexOf(""+searchValue+"") !== -1 ){
                    $(this).closest(settings.itemSelector).show();
                }
            });
        }

        this.each( function() {

            let elem = $( this );

            // if initialized run triggered event
            if (typeof elem != 'undefined' && elem.hasClass(config.isInitializedClassName+'-events')) {
                let targetListSelector = elem.attr(settings.dataTargetAttr);
                uiFilterSearchMatches(targetListSelector, elem.val());
            }

            // bind events
            if( !elem.hasClass(config.isInitializedClassName+'-events') ) {
                elem.on(settings.onEvents, function(e) {
                    elem.uiSearchableList( settings );
                }).addClass(config.isInitializedClassName+'-events');
            }
        });

        return this;
    };

    function pageLoaded(){
        $('.ui-searchable-list-listener').uiSearchableList({onEvents: 'input blur'});
    }

    // add livewire navigated listener
    document.addEventListener('livewire:navigated', function () {
        pageLoaded();
    });

    // livewire is not installed
    if (typeof Livewire === "undefined") {
        // do jquery basic stuff after page has loaded
        $(function(){
            pageLoaded();
        });
    }

}(jQuery));
